<template>
  <div class="callback-container">
    <div class="card" v-if="loading">
      <div class="spinner"></div>
      <h2>Verifierar inloggning...</h2>
      <p>Vänligen vänta medan vi verifierar din inloggningslänk.</p>
    </div>
    <div class="card error" v-else-if="error">
      <div class="error-icon">⚠️</div>
      <h2>Inloggningen misslyckades</h2>
      <p class="error-msg">{{ errorMessage }}</p>
      <router-link to="/logga-in?admin=1" class="btn">Gå till inloggning</router-link>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import API from '@/classes/API';

export default {
  data() {
    return {
      loading: true,
      error: false,
      errorMessage: '',
      email: '',
      token: '',
    };
  },
  methods: {
    ...mapMutations([
      'setUser',
    ]),
    async verify() {
      this.email = this.$route.query.email || '';
      this.token = this.$route.query.token || '';

      if (!this.email || !this.token) {
        this.loading = false;
        this.error = true;
        this.errorMessage = 'Ogiltig inloggningslänk. E-postadress eller token saknas.';
        return;
      }

      try {
        const response = await API.post('/account/magic-verify', {
          email: this.email,
          token: this.token,
        });

        if (response.success) {
          // Commit to state
          const u = response.user;
          u.isAdmin = Boolean(u.isAdmin || u.can_accomodations || u.can_translations);
          u.token = 'session-auth';
          this.$store.state.user = u;

          this.setUser({
            token: 'session-auth',
          });

          // Notify state changed
          document.body.dispatchEvent(new CustomEvent('bookinguserstatechanged', { detail: true }));

          // Redirect to admin
          this.$router.push('/admin');
        } else {
          this.loading = false;
          this.error = true;
          this.errorMessage = response.errorMessage || 'Kunde inte verifiera inloggningen.';
        }
      } catch (err) {
        this.loading = false;
        this.error = true;
        this.errorMessage = err.response && err.response.data && err.response.data.errorMessage
          ? err.response.data.errorMessage
          : 'Ett fel uppstod under verifieringen av inloggningslänken.';
      }
    },
  },
  mounted() {
    this.verify();
  },
};
</script>

<style scoped>
.callback-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 80vh;
  background-color: #f7f9fa;
  font-family: sans-serif;
}

.card {
  background: white;
  padding: 40px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
  text-align: center;
  max-width: 400px;
  width: 100%;
}

.card.error {
  border-top: 4px solid #d9534f;
}

.spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border-left-color: #005580;
  animation: spin 1s linear infinite;
  margin: 0 auto 20px auto;
}

.error-icon {
  font-size: 48px;
  margin-bottom: 15px;
}

h2 {
  color: #333;
  margin-bottom: 10px;
  font-size: 22px;
}

p {
  color: #666;
  font-size: 15px;
  line-height: 1.5em;
  margin-bottom: 25px;
}

.error-msg {
  color: #d9534f;
  background: #fdf7f7;
  padding: 12px;
  border-radius: 4px;
  border: 1px solid #f2dede;
}

.btn {
  display: inline-block;
  background: #005580;
  color: white;
  padding: 10px 20px;
  text-decoration: none;
  border-radius: 4px;
  font-weight: bold;
  transition: background 0.2s;
}

.btn:hover {
  background: #004466;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// AuthCallback.vue?cc33eeb6